import React, { useEffect, useRef, useState } from 'react';
import UploadImage from '../../util_components/upload_image';

// Photo + signature via upload_image; the returned URL is stored as-is (E20).
// on_uploading(bool): parent blocks Save while an upload is in flight.
export default function CmsImageFields({
  profile_photo,
  signature_image,
  on_change,
  notify,
  on_uploading
}) {
  const [uploading, setUploading] = useState(false);
  const pending = useRef(0);
  // A late upload from an unmounted instance must not touch the next form.
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  const bump = (delta) => {
    if (!alive.current) return;
    pending.current = Math.max(0, pending.current + delta);
    const now = pending.current > 0;
    setUploading(now);
    if (on_uploading) on_uploading(now);
  };
  const set_notification_variable = (_show, type, message) => notify(type, message);
  const common = {
    // Always '': apis upload_image's non-empty-uuid branches have no 'cms_users' case and never respond.
    uuid: '',
    folder_name: 'cms_users',
    change_input: (key, url) => {
      if (alive.current) on_change(key, url);
    },
    set_notification_variable,
    start_loading: () => bump(1),
    stop_loading: () => bump(-1)
  };
  return (
    <>
      <div>
        <div className="cms-field-label">Profile photo:</div>
        <UploadImage
          {...common}
          image_type="profile_photo"
          imageUrl={profile_photo}
          buttonTitle={profile_photo ? 'Change photo' : 'Upload photo'}
        />
      </div>
      <div>
        <div className="cms-field-label">Signature image:</div>
        <UploadImage
          {...common}
          image_type="signature_image"
          imageUrl={signature_image}
          buttonTitle={signature_image ? 'Change signature' : 'Upload signature'}
        />
      </div>
      {uploading ? <div data-testid="cms-uploading">Uploading…</div> : null}
    </>
  );
}
